var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "booking_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M45 16H3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 42H7a4 4 0 01-4-4V10a4 4 0 014-4h34a4 4 0 014 4v15.012M13 2v8M35 2v8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 37,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 33v8M31 37h8"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+ZXZlbnQgY3JlYXRlPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48bGluZSBkYXRhLWNhcD0iYnV0dCIgeDE9IjQ1IiB5MT0iMTYiIHgyPSIzIiB5Mj0iMTYiPjwvbGluZT48cGF0aCBkPSJNMjEsNDJIN2MtMi4yMDksMC00LTEuNzkxLTQtNFYxMGMwLTIuMjA5LDEuNzkxLTQsNC00SDQxYzIuMjA5LDAsNCwxLjc5MSw0LDR2MTUuMDEyIj48L3BhdGg+PGxpbmUgeDE9IjEzIiB5MT0iMiIgeDI9IjEzIiB5Mj0iMTAiPjwvbGluZT48bGluZSB4MT0iMzUiIHkxPSIyIiB4Mj0iMzUiIHkyPSIxMCI+PC9saW5lPjxjaXJjbGUgY3g9IjM1IiBjeT0iMzciIHI9IjkiIHN0cm9rZT0iIzI3MjcyNiI+PC9jaXJjbGU+PGxpbmUgeDE9IjM1IiB5MT0iMzMiIHgyPSIzNSIgeTI9IjQxIiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT48bGluZSB4MT0iMzEiIHkxPSIzNyIgeDI9IjM5IiB5Mj0iMzciIHN0cm9rZT0iIzI3MjcyNiI+PC9saW5lPjwvZz48L3N2Zz4=";
export { SvgBooking as ReactComponent };